/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { IconContext } from 'react-icons';
import LogoBlue from 'src/assets/logo_pride_mini.svg';
import { ReactComponent as LogoText } from 'src/assets/logo_text.svg';

import { ReactComponent as NotificationsBell } from 'src/assets/notification-bell.svg';
import { ReactComponent as SupportDeskIcon } from 'src/assets/support_desk.svg';
import { ReactComponent as Logout } from 'src/assets/logout.svg';
import Notifications from 'src/modules/notifications';
import ValidateUserService from 'src/services/validateUser.service';
import logoutService from 'src/services/logout.service';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { ReactComponent as SupportDeskNewIcon } from '../../assets/Support Ticket.svg';
import { ReactComponent as HelpSupportIcon } from '../../assets/help-Icon.svg';
import { ReactComponent as LeaveIcon } from '../../assets/Leave Application Icon.svg';
import { ISidebar } from 'src/interfaces';
import {
  NavMenu,
  LogoContainer,
  LogoImg,
  NavMenuItems,
  NavText,
  NavTextLink,
  NavTextTitle,
  MainContainer,
  NotificationWrapper,
  NavTextWithoutLink,
} from './styles';
import './index.css';

export const SideBar: React.FC<{
  sidebarData: ISidebar[];
  children: { children: React.ElementType };
}> = ({ sidebarData, children }) => {
  const [sidebar, setSidebar] = useState(false);
  const [notification, setNotification] = useState(false);
  const [mainContainerColor, setMainContainerColor] = useState('#f3f4f8');
  const [modules] = useLocalStorage('modules', []);
  const [typedUsername] = useLocalStorage('typedUsername', '');

  const usernameRaw = localStorage.getItem('typedUsername');
  const username = usernameRaw ? JSON.parse(usernameRaw) : null;

  const [token] = useLocalStorage('accessToken', null);

  const handleLogout = () => {
    logoutService.logout();
  };

  const handleSidebar = () => {
    setSidebar(!sidebar);
  };

  useEffect(() => {
    const validate = async () => {
      try {
        if (token) {
          const usernameRaw = localStorage.getItem('typedUsername');
          const username = usernameRaw ? JSON.parse(usernameRaw) : null;
          if (username) {
            await ValidateUserService.validate(username);
          }
        }
      } catch {
        console.log('what happed');
        logoutService.logout();
      }
    };

    validate();
  }, []);

  return (
    <>
      <IconContext.Provider value={{ size: '25px' }}>
        <NavMenu active={sidebar} onMouseEnter={handleSidebar} onMouseLeave={handleSidebar}>
          <NavMenuItems>
            <LogoContainer>
              <LogoImg src={LogoBlue} />
              <LogoText />
            </LogoContainer>
            {sidebarData.map((item: ISidebar) => {
              if (modules.includes(item.permission)) {
                return (
                  <NavText key={item.path}>
                    <NavTextLink
                      to={item.path}
                      expanded={sidebar ? 1 : 0}
                      // onClick={() => setMainContainerColor(item.backgroundColor)}
                      // onClick={async () => {
                      //   setMainContainerColor(item.backgroundColor);

                      //   try {
                      //     if (token && typedUsername) {
                      //       await ValidateUserService.validate(typedUsername);
                      //     }
                      //   } catch (err) {
                      //     logoutService.logout();
                      //   }
                      // }}

                      onClick={async () => {
                        setMainContainerColor(item.backgroundColor);
                        try {
                          // const username = localStorage.getItem('typedUsername');

                          const usernameRaw = localStorage.getItem('typedUsername');
                          const username = usernameRaw ? JSON.parse(usernameRaw) : null;
                          if (token && username) {
                            await ValidateUserService.validate(username);
                          }
                        } catch {
                          logoutService.logout();
                        }
                      }}
                    >
                      <item.icon />
                      <NavTextTitle>{item.name}</NavTextTitle>
                    </NavTextLink>
                  </NavText>
                );
              }
            })}
          </NavMenuItems>
          <NavMenuItems>
            <NavText>
              <NavLink to="/help-support" style={{ textDecoration: 'none' }}>
                <NotificationWrapper expanded={sidebar ? 1 : 0}>
                  <HelpSupportIcon />
                  <NavTextTitle>Help Support</NavTextTitle>
                </NotificationWrapper>
              </NavLink>
            </NavText>
            <NavText
              onClick={() => {
                setNotification(!notification);
              }}
            >
              <NotificationWrapper expanded={sidebar ? 1 : 0}>
                <NotificationsBell />
                <NavTextTitle>Notifications</NavTextTitle>
              </NotificationWrapper>
            </NavText>
            <NavText onClick={handleLogout}>
              <NavTextWithoutLink expanded={sidebar ? 1 : 0}>
                <Logout />
                <NavTextTitle>Logout</NavTextTitle>
              </NavTextWithoutLink>
            </NavText>
          </NavMenuItems>
        </NavMenu>
      </IconContext.Provider>
      <MainContainer backgroundColor={mainContainerColor}>{children}</MainContainer>
      <Notifications open={notification} />
    </>
  );
};
